<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row" v-if="!isPageLoading">
                <div class="col-md-12">
                    <notifications />
                    
                    <div class="alert alert-dark fade show mb-3" style="border-color: red;" v-if="changeAcceptanceMessage">
                        <div class="row" >
                            <div class="col-md-12">
                                <p style="padding-top: 15px;">We are very sorry, there has been a change to your original holiday booking.</p>
                                <p style="padding-top: 15px" v-if="booking.intimate_customer_reasons && booking.intimate_customer_reasons.length > 0 ">
                                    <ul style="margin-top: 10px;">
                                        <li v-for="reason in booking.intimate_customer_reasons" :key="reason">{{ reason }}</li>
                                    </ul>
                                </p>
                                <p style="padding-top: 15px;">
                                    Please review the new holiday details below. If these new
                                    holiday details are OK with you, please click the 'Accept' button so we can
                                    re-confirm your holiday booking.
                                </p>
                                <p style="padding-top: 15px;">
                                    If the changes are not suitable for you, please call our Reservations Team on
                                    01352 756864 so we can discuss alternative options for you.
                                </p>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12 text-center">
                                <button type="button" class="btn btn-primary" style="margin-right: 10px" @click="handleChangeAcceptance">
                                    Accept
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row g-4">
                                <!-- Main Flight Card -->
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="card flight-card">
                                                <div class="card-body p-4">
                                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                                        <div>
                                                            <h5 class="d-flex align-items-center gap-2 text-primary">
                                                               <b>{{ booking.tour_bookings[0].tour.name }}</b>
                                                            </h5>
                                                            <small class="text-muted">
                                                                Depart From <b>{{ booking.tour_bookings[0].instance.airport.airport_name }}</b>
                                                            </small>
                                                            <br/>
                                                            <small class="text-muted">
                                                                Depart on <b>{{ booking.soonest_departure | formatDate}}</b>
                                                            </small>
                                                        </div>
                                                        <b>#{{ booking.booking_ref}}</b>
                                                    </div>
                        
                                                    <div class="flight-path position-relative">
                                                        <template v-for="(bookingFlight, index) in bookingFlights">
                                                            <div class="row" :key="index">
                                                                <div class="col-md-12">
                                                                    <div class="row align-items-center flight-card-inner" >
                                                                        <div class="col-md-12">
                                                                            <h5 class="mb-1">Outbound</h5>
                                                                            <div class="mt-1">
                                                                                <template v-for="(departureF, InnerIndexD) in bookingFlight.departure_flights" >
                                                                                    <div :key="InnerIndexD">
                                                                                        <div class="border-bottom">
                                                                                            <div class="d-flex justify-content-between py-2" >
                                                                                                <span>
                                                                                                    {{departureF.departure_airport.airport_name}} ({{ departureF.departure_airport.iata_code }})
                                                                                                     → 
                                                                                                    {{departureF.arrival_airport.airport_name}} ({{departureF.arrival_airport.iata_code}})
                                                                                                </span>
                                                                                                <span class="text-muted">
                                                                                                    {{ departureF.departure_time | formatTimeShort }} - {{ departureF.arrival_time | formatTimeShort }}
                                                                                                </span>
                                                                                            </div>
                                                                                            <small> {{ departureF.departure_time | formatDate }} ( {{ departureF.selected_airline.name }} )</small>
                                                                                        </div>
                                                                                    </div>
                                                                                </template>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                
                                                                    <div class="row align-items-center flight-card-inner mt-3" >
                                                                        <div class="col-md-12">
                                                                            <h5 class="mb-1">Return</h5>
                                                                            <div class="mt-1">
                                                                                <template v-for="(ArrivalF, InnerIndexA) in bookingFlight.return_flights" >
                                                                                    <div  :key="InnerIndexA">
                                                                                        <div class="border-bottom">
                                                                                            <div class="d-flex justify-content-between py-2">
                                                                                                <span>
                                                                                                    {{ArrivalF.departure_airport.airport_name}} ({{ ArrivalF.departure_airport.iata_code }})
                                                                                                     → 
                                                                                                    {{ArrivalF.arrival_airport.airport_name}} ({{ArrivalF.arrival_airport.iata_code}})
                                                                                                </span>
                                                                                                <span class="text-muted">
                                                                                                    {{ ArrivalF.departure_time | formatTimeShort }} - {{ ArrivalF.arrival_time | formatTimeShort }}
                                                                                                </span>
                                                                                            </div>
                                                                                            <small> {{ ArrivalF.departure_time | formatDate }} ( {{ ArrivalF.selected_airline.name }} )</small>
                                                                                        </div>
                                                                                    
                                                                                    </div>
                                                                                </template>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                    
                                                                    <div class="row mt-3">
                                                                        <div class="col-md-12">
                                                                            <div class="booking-info">
                                                                                <div class="row">  <!-- Added g-2 class for tighter row gutters -->
                                                                                    <div class="col-md-6">
                                                                                        <div class="info-label">
                                                                                            Airline booking ref.
                                                                                        </div>
                                                                                        <div class="info-value">
                                                                                            {{ airBookingRefText(bookingFlight.tour_booking.airline_ref) }}
                                                                                        </div>
                                                                                        <div class="reference-note" v-if="daysBeforeDeprture() > 28">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle me-1" viewBox="0 0 16 16">
                                                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                                                                            </svg>
                                                                                            Airline reference will be available within 28 days of departure
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-6" v-if="daysBeforeDeprture() <= 28">
                                                                                        <div class="info-label">
                                                                                            Email
                                                                                        </div>
                                                                                        <div class="info-value" v-if="bookingFlight.tour_booking.instance.flights.length > 0 && bookingFlight.tour_booking.instance.flights[0].selected_airline.name.toLowerCase() == 'ryanair'">
                                                                                            <a :href="airLineRefEmail" class="text-primary text-decoration-none">
                                                                                                {{ airLineRefEmail }}
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="divider"></div>
                                                                                <div class="row">
                                                                                    <div class="col-12">
                                                                                    <div class="info-label">Check in instructions</div>
                                                                                    <div class="info-value mb-0">  
                                                                                        <template v-if="booking.airline_detail && booking.airline_detail.instruction_doc_path">
                                                                                            <a href="javascript:void(0)" 
                                                                                                class="btn btn-outline-primary btn-sm py-1"
                                                                                                v-on:click="downloadCheckInDocument(booking.airline_detail.id, booking.airline_detail.instruction_doc_name)"
                                                                                            >  <!-- Reduced button padding -->
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-text me-1" viewBox="0 0 16 16">
                                                                                                    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                                                                                                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                                                                                                </svg>
                                                                                                View Instructions
                                                                                            </a>
                                                                                        </template>
                
                                                                                        <template v-else-if="bookingFlight.tour_booking.instance.flights.length > 0 && bookingFlight.tour_booking.instance.flights[0].airline.toLowerCase() == 'ryanair'">
                                                                                            <a href="javascript:void(0)" 
                                                                                                class="btn btn-outline-primary btn-sm py-1"
                                                                                                v-on:click="downloadRyanairCheckIn()"
                                                                                            >  <!-- Reduced button padding -->
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-text me-1" viewBox="0 0 16 16">
                                                                                                    <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                                                                                                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                                                                                                </svg>
                                                                                                View Instructions
                                                                                            </a>
                                                                                        </template>
                                                                                    </div>
                                                                                    </div>
                                                                                </div>
                                                                                </div>
                                                                        </div>
                                                                    </div>
                
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div class="card flight-card">
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                                        <h5 class="d-flex align-items-center gap-2 text-primary">
                                                            <b>Accomodation</b>
                                                        </h5>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <template v-for="tour_booking of booking.tour_bookings">
                                                                <div class="row" :key="tour_booking.id">
                                                                    <div class="col-md-6" >
                                                                        <p class="mb-1"><b>Hotel:</b> {{ tour_booking.room.accommodation.details.accommodation_name }}</p>
                                                                        <p class="mb-1"><b>Room:</b> {{ tour_booking.room.name }}</p>
                                                                        <p class="mb-0"><b>Board:</b> {{ tour_booking.room.board_basis }}</p>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row mt-2" v-if="booking.customer_id">
                                        <div class="col-md-12">
                                            <div class="card flight-card">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="mb-4">
                                                                <h5 class="d-flex align-items-center gap-2 text-primary">
                                                                    <b>
                                                                        Customer Contact Details
                                                                    </b>
                                                                </h5>
                                                                
                                                                <div class="ms-4 mt-3">
                                                                    <div class="row mb-2">
                                                                        <div class="col-sm-3 fw-semibold">Name:</div>
                                                                        <div class="col-sm-9">{{ customerContactDetails.name ? customerContactDetails.name : '--' }} </div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-sm-3 fw-semibold">Email:</div>
                                                                        <div class="col-sm-9">{{ customerContactDetails.email ? customerContactDetails.email : '--'  }}</div>
                                                                    </div>
                                                                    <div class="row mb-2">
                                                                        <div class="col-sm-3 fw-semibold">Mobile Number:</div>
                                                                        <div class="col-sm-9">
                                                                            <div class="input-group" style="max-width: 300px;">
                                                                                <input type="tel" 
                                                                                    class="form-control" 
                                                                                    v-model="customerContactDetails.phone_number"
                                                                                    maxlength="10"
                                                                                    placeholder="Enter mobile number">
                                                                                <button class="btn btn-primary" type="button" @click="updateCustomerDetail">
                                                                                    <i class="bi bi-check-lg me-1"></i>
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row mt-2">
                                        <div class="col-md-12">
                                            <div class="card flight-card">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <h5 class="d-flex align-items-center gap-2 text-primary">
                                                                <b>Passengers</b>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    
                                                    <template v-if="booking.passengers.length > 0 "></template>
                                                    <div class="row mt-3">
                                                        <div class="col-md-12">
                                                            <div class="accordion" id="accordionExample">
                                                                <!-- First Tab -->
                                                                <div class="passenger-container accordion-item mt-2" v-for="(passenger, index) in booking.passengers" :key="'passenger-'+passenger.id">
                                                                    <h5 class="accordion-header">
                                                                        <b> {{ passenger.title }} {{ passenger.full_name }} </b>
                                                                    </h5>
                                                                    <div id="collapseOne" class="accordion-collapse collapse show">
                                                                        <div class="accordion-body">
                                                                            <hr>
                                                                            <div class="row mt-2">
                                                                                <div class="col-md-12">
                                                                                    <div class="row">
                                                                                        <template v-if="booking.tour_bookings[0].tour.is_passport_details_required">
                                                                                            <div class="col-md-12">
                                                                                                <template v-if="!passenger.passport_no && !passenger.passport_issue && !passenger.passport_expiry && !passenger.passport_nationality">
                                                                                                    <p class="text-success">
                                                                                                        Please complete the passport information below.
                                                                                                    </p>
                                                                                                </template>
                                                                                            </div>
                                                                                        </template>
                                                                                    </div>
                                                                                    <template v-if="booking.tour_bookings[0].tour.is_passport_details_required">
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                <label for="" class="form-label-custom" >Passport Number</label>
                                                                                                <input type="text"
                                                                                                    class="form-control" 
                                                                                                    :id="`Passenger-passport-number-${passenger.id}`" 
                                                                                                    :readonly="!passenger.can_edit_passport_details"
                                                                                                    v-model="passenger.passport_no"
                                                                                                    placeholder="Passport Number">
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                <label for="" class="form-label-custom" >Passport Issued Date</label>
                                                                                                <input type="date"
                                                                                                    class="form-control" 
                                                                                                    :id="`Passenger-passport-isseu-date-${passenger.id}`" 
                                                                                                    :readonly="!passenger.can_edit_passport_details"
                                                                                                    v-model="passenger.passport_issue"
                                                                                                    placeholder="Passport Issued Date">
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                <label for="" class="form-label-custom" >Passport Expiry Date</label>
                                                                                                <input type="date"
                                                                                                    class="form-control" 
                                                                                                    :id="`Passenger-passport-expired-date-${passenger.id}`" 
                                                                                                    v-model="passenger.passport_expiry"
                                                                                                    :readonly="!passenger.can_edit_passport_details"
                                                                                                    placeholder="Passport Expiry Date">
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row">
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                <label for="" class="form-label-custom" >Passport Nationality</label>
                                                                                                <input type="text"
                                                                                                    class="form-control" 
                                                                                                    :id="`Passenger-passport-nationality-${passenger.id}`" 
                                                                                                    :readonly="!passenger.can_edit_passport_details"
                                                                                                    v-model="passenger.passport_nationality"
                                                                                                    placeholder="Passport Nationality">
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-md-4">
                                                                                                <div class="form-group">
                                                                                                <label for="" class="form-label-custom">Date of Birth</label>
                                                                                                <input type="date"
                                                                                                    class="form-control" 
                                                                                                    :id="`Passenger-passport-date_of_birth-${passenger.id}`" 
                                                                                                    v-model="passenger.dob"
                                                                                                    :readonly="!passenger.can_edit_dob"
                                                                                                    placeholder="Date of Birth"
                                                                                                    :max="momentObject().format('YYYY-MM-DD')">
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="row mt-3">
                                                                                            <div class="col-md-12">
                                                                                                <button class="btn btn-sm btn-primary" type="button" style="float:right" @click="updatePassengerDetails(passenger.id, index)">
                                                                                                    Save
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <hr/>
                                                                                    </template>
                                                                                    <div class="row">
                                                                                        <div class="col-md-12">
                                                                                            <template v-if="!passenger.policy_number && !passenger.insurance_company && !passenger.insurance_telephone_number">
                                                                                                <p style="font-size: 12px;
                                                                                                    font-weight: 600;">
                                                                                                    Holiday insurance is compulsory as advised in our terms & conditions. 
                                                                                                    Please complete the form below with your insurance details.
                                                                                                </p>
                                                                                            </template>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row mt-2">
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                            <label for="" class="form-label-custom" >Policy Number</label>
                                                                                            <input type="text"
                                                                                                class="form-control" 
                                                                                                :id="`Passenger-policy-number-${passenger.id}`"
                                                                                                v-model="passenger.policy_number"
                                                                                                placeholder="Policy Number">
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                            <label for="" class="form-label-custom" >Insurance Company</label>
                                                                                            <input type="text"
                                                                                                class="form-control" 
                                                                                                :id="`Passenger-insurance-company-${passenger.id}`" 
                                                                                                v-model="passenger.insurance_company"
                                                                                                placeholder="Insurance Company">
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                            <label for="" class="form-label-custom" >Insurer Telephone Number</label>
                                                                                            <input type="text"
                                                                                                class="form-control" 
                                                                                                :id="`Passenger-insurance-telephone-number-${passenger.id}`" 
                                                                                                v-model="passenger.insurance_telephone_number"
                                                                                                placeholder="Insurer Telephone Number">
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row mt-3">
                                                                                <div class="col-md-12">
                                                                                    <button class="btn btn-sm btn-primary" type="button" style="float:right" @click="updatePassengerDetails(passenger.id, index)">
                                                                                        Save
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                
                                <!-- Side Cards -->
                                <div class="col-md-4">
                                    <!-- Ticket Actions -->
                                    <div class="card flight-card mb-4">
                                        <div class="card-body p-3">
                                            <h6 class="card-title mb-3">Booking Documents</h6>
                                            <div class="ticket-actions">
                                                <button class="btn btn-sm btn-primary" v-on:click="download('invoice')">Confirmation</button>
                                                <button class="btn btn-sm btn-primary" v-on:click="download('atol')">ATOL Cert.</button>
                                                <button class="btn btn-sm btn-primary" :disabled="booking.balance > 0 || !booking.allow_customer_itinerary" v-on:click="emailItinerary">Email Travel Itinerary</button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Pricing Breakup -->
                                    <div class="card flight-card" v-if="booking.customer_id">
                                        <div class="card-body p-3">
                                            <h6 class="card-title mb-3">Booking Costs</h6>
                                            <div class="pricing-breakup">
                                                <div class="pricing-row">
                                                    <span><b>Total holiday price:</b></span>
                                                    <span>{{ booking.total_due | formatCurrency }}</span>
                                                </div>
                                                <div class="pricing-row">
                                                    <span><b>Deposit paid:</b></span>
                                                    <span>{{ booking.paid | formatCurrency }}</span>
                                                </div>
                                                <div class="pricing-row">
                                                    <span><b>Balance:</b></span>
                                                    <span>{{ booking.balance | formatCurrency }}</span>
                                                </div>
                                                <div class="pricing-row" v-if="booking.balance > 0">
                                                    <small>(Due by {{ booking.balance_due | formatDate }})</small>
                                                    <!-- <button class="btn btn-sm btn-primary" v-on:click="download('atol')">ATOL Cert.</button> -->
                                                </div>
                                                <div class="pricing-row mt-3" v-if="booking.balance > 0">
                                                    <button class="btn btn-sm btn-primary" v-on:click="takePayment()">Pay Balance</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Modal -->
                    <div id="success_tic" class="modal fade in show" role="dialog" v-if="changeAcceptance" 
                        tabindex="-1" aria-modal="true" style="display:block; backdrop-filter: blur(5px) contrast(.1);">
                        <div class="modal-dialog modal-confirm">
                            <div class="modal-content">
                                <div class="modal-header justify-content-center">
                                    <div class="icon-box">
                                        <div class="checkmark draw"></div>
                                    </div>
                                </div>
                                <div class="modal-body text-center">
                                    <h4>Thank you!</h4>	
                                    <p>
                                        Thank you for accepting the changes made to your original booking. 
                                        These changes have now been confirmed and we have emailed you a new booking confirmation. 
                                        You will now be redirected to the <strong>'My Booking'</strong> section of our website 
                                        where you can also view all of the details for your holiday.
                                    </p>
                                    <button class="btn btn-success" @click="verfiedRedirect"> <span> Go to My Booking </span> </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-5" v-else>
                <div class="col-md-12">
                    <div class="loader-container">
                        <div class="dotted-line"></div>
                        <div class="loading-text">Please wait, while we are fetching booking details...</div>
                        <div class="destination-icons">
                            <span>🗽</span>
                            <span>🗼</span>
                            <span>🏰</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'VerifiedBookingDetail',
    data () {
        return {
            isLoading: false,
            isPageLoading:true,
            verify: JSON.parse(localStorage.getItem('verify')),
            booking: null,
            paymentCompleted : false,
            changeAcceptance:false,
            momentObject:null
        }
    },
    mounted() {
        if (localStorage.getItem('verify') === null || !localStorage.getItem('verify') || localStorage.getItem('verify') === 'undefined') {
            this.$router.push({ name: 'verify' })
        }
    },
    created() {
        let changeVerification = this.$route.query.changeVerification
        if (changeVerification) {
            this.changeAcceptance = true
        }
        this.getBooking()
        if(this.$root.stripeLoaded == false) {
            let stripeJS = document.createElement('script')
            stripeJS.setAttribute('src', 'https://js.stripe.com/v3/')
            document.head.appendChild(stripeJS)
            this.$root.stripeLoaded = true
        }

        this.momentObject = moment
    },
    computed: {
        customerContactDetails() {
            let contactDetails = {
                name: '',
                email: '',
                phone_number: ''
            }

            if (this.booking.customer_id) {
                contactDetails = {
                    name: `${(this.booking.customer.title) ? this.booking.customer.title : '' } ${this.booking.customer.full_name}`,
                    email: this.booking.customer.email,
                    phone_number: this.booking.customer.mobile_number
                }
            } else if(this.booking.agent_id) {
                contactDetails = {
                    name: `${this.booking.agent.name}`,
                    email: this.booking.agent.email,
                    phone_number: this.booking.agent.phone_number
                }
            }

            return contactDetails
        },
        changeAcceptanceMessage(){
            if (this.booking && this.booking.changes_accepted == 0 ) {
                return true
            }else{
                return false
            }
        },
        bookingFlights() {
            let tourBookingFLights = [];
            if (this.booking.tour_bookings.length > 0) {
                this.booking.tour_bookings.forEach(element => {
                    const tourDate = new Date(element.departure_date).setHours(0, 0, 0, 0);
                    let departureFlighArray = [];
                    let returnFlightArray = [];
                    if (element.instance.flights.length === 2) {
                        departureFlighArray.push(element.instance.flights[0])
                        
                        returnFlightArray.push(element.instance.flights[1])
                    }else{
                        // Get Inbound Flights Array
                        let inboundFlights = element.instance.flights.filter((item) => item.pivot.indirect_inbound == 1)
                        // Get Outbount Flights Array
                        let outBoundFlights = element.instance.flights.filter((item) => item.pivot.indirect_outbound == 1)

                        if (inboundFlights.length > 0  && outBoundFlights.length > 0 ) {
                            departureFlighArray = outBoundFlights
                            returnFlightArray = inboundFlights
                        } else {
                            departureFlighArray.push(element.instance.flights.reduce((carry, flight) => {
                                const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                                return (flightDate === tourDate) ? flight : carry;
                            }, null))

                            returnFlightArray.push(element.instance.flights.reduce((carry, flight) => {
                                const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                                return (flightDate !== tourDate) ? flight : carry;
                            }, null))
                        }
                    }

                    tourBookingFLights.push({
                        'tour_booking' : element,
                        'departure_flights': departureFlighArray,
                        'return_flights' : returnFlightArray
                    })
                });
            }
            return tourBookingFLights
        },
        airLineRefEmail() {
            let email = null;
            if (this.booking.airline_reference_email) {
                email = this.booking.airline_reference_email
            } else {
                if (this.booking.customer_id) {
                    email = this.booking.customer.first_name.toLowerCase() + '.' + this.booking.customer.last_name.toLowerCase() + '@mymist.co.uk'
                }
            }
            return email
        }
       
    },
    methods: {
        getBooking() {
            axios.post(this.$root.$api + 'manage-bookings/get-booking', {
                booking_ref_no: this.verify.booking_ref_no,
                surname: this.verify.surname,
                departure_date: this.verify.departure_date,
            })
            .then(res => res.data)
            .then(json => {
                if (typeof(json.success) === 'undefined' || !json.success) {
                    this.$notify({
                        type: 'error',
                        title: json.error
                    });
                    return;
                }

                let bookingDetail = json.data.booking
                bookingDetail.passengers = bookingDetail.passengers.map((element) => {
                    return {
                        ...element,
                        can_edit_passport_details: (element.passport_no && element.passport_nationality && element.passport_expiry && element.passport_issue) ? false: true,
                        can_edit_dob: (element.dob) ? false: true,
                    }
                })

                this.booking = bookingDetail;
            })
            .catch( function (error) {
                console.log(error)
                this.$notify({
                    type: 'error',
                    title: 'An error occured!'
                });
            })
            .finally(() => {
                this.isPageLoading = false    
            })
        },
        download(docType) {            
            const allowedDocTypes = ['invoice', 'atol', 'itin'];
            if (!allowedDocTypes.includes(docType)) {
                this.$notify({
                    type: 'error',
                    title: 'Invalid document.'
                });
                return;
            }
            this.isLoading = true;
            axios.post(this.$api + 'manage-bookings/' + this.booking.id + '/documents/' + docType, {
                booking_ref_no: this.verify.booking_ref_no,
                surname: this.verify.surname,
                departure_date: this.verify.departure_date,
                }, {
                headers: {
                    'Accept': 'application/json',
                }
            })
            .then(res => res.data)
            .then(response => {
                this.isLoading = false;
                if (response.success != true) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                    return;
                }
                if(response.success == true) window.open(this.$api + 'bookings/document/' + this.booking.id + '-' + docType + '.pdf/download', '_blank');
            })
            .catch(error => {
                console.log(error);
                this.$root.loading = false;
            })
        },

        downloadRyanairCheckIn() {
            window.open(this.$api + 'bookings/document/ryanair_check_in.pdf/download', '_blank');
        },

        downloadCheckInDocument(id, filename) {
            axios.get(this.$api + 'manage-bookings/airline_checkin/' + id + '/documents/download', {
                params: {
                    booking_ref_no: this.verify.booking_ref_no,
                    surname: this.verify.surname,
                    departure_date: this.verify.departure_date,
                },
                headers: {
                    'Accept': 'application/json',
                },
                responseType: 'blob'
            })
            .then(response => {
                if(response.data) {
                    const _url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', `${filename}`)
                    document.body.appendChild(link)
                    link.click();
                }
            }).catch(error => {
                this.$root.loading = false;
                console.log(error.response.data.message, 'sasa')
                if(error.response.data.message) {
                    this.$notify({
                        type: 'error',
                        title: error.response.data.message
                    });
                }else {
                    this.$notify({
                        type: 'error',
                        title: 'File does not exists.'
                    });
                }
            });
        },

        takePayment() {
            this.$root.loading = true;
            axios.get(this.$root.$api + 'bookings/payment')
            .then(res => res.data)
            .then(response => {
                if(response.data === 'stripe') {
                    this.payWithStripe();
                } else if(response.data === 'ecommpay') {
                    this.payWithEcommpay();
                } else {
                    this.$notify({
                        type: 'error',
                        title: 'No payment gateway found'
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$root.loading = false;
            })
        },
        payWithStripe() {
            const stripe = Stripe(process.env.MIX_STRIPE_PUBLIC);

            axios.post(this.$root.$api + 'bookings/pay', {
                'booking_ref': this.booking.booking_ref,
                'description': 'Balance payment of ' + this.booking.booking_ref,
                'booking_id': this.booking.id,
                'customer_id':  this.booking.customer.id,
                // @TODO: adjust amount due to full amount if tour is x days away
                'amount': this.booking.balance * 10,
                'success_url': process.env.MIX_APP_URL + '/my-bookings#/confirmation?id={CHECKOUT_SESSION_ID}',
                'cancel_url': process.env.MIX_APP_URL + '/my-bookings#/failure'
            })
            .then(res => res.data)
            .then(response => {
                this.$root.loading = false;
                stripe.redirectToCheckout({
                sessionId: response.data.id
                }).then((result) => {
                    this.$root.loading = false
                    this.$router.push({ name: 'failure' })
                });
            })
            .catch(error => {
                // console.log(error);
            })
        },
        payWithEcommpay() {
            let __this = this
            axios.post(this.$root.$api + 'bookings/ecommpay/pay', {
                'booking_ref': this.booking.booking_ref,
                'description': 'Balance payment of ' + this.booking.booking_ref,
                'booking_id': this.booking.id,
                'customer_id':  this.booking.customer.id,
                // @TODO: adjust amount due to full amount if tour is x days away
                'amount': this.booking.balance,
                'success_url': process.env.MIX_APP_URL + '/my-bookings#/confirmation',
                'cancel_url': process.env.MIX_APP_URL + '/my-bookings#/failure'
            })
            .then(res => res.data)
            .then(response => {
                this.$root.loading = false;
                // window.location.href = response.redirect;
                const self  = this;
                EPayWidget.run(
                    {
                        "project_id": response.data.project_id,
                        "interface_type": response.data.interface_type,
                        "payment_id": response.data.payment_id,
                        "payment_amount": response.data.payment_amount,
                        "payment_currency": response.data.payment_currency,
                        "payment_description": response.data.payment_description,
                        "customer_id": response.data.customer_id,
                        "payment_extra_param": response.data.payment_extra_param,
                        "merchant_return_url": response.data.merchant_return_url,
                        "signature": response.data.signature,
                        onPaymentSuccess: function () {
                            self.paymentCompleted = true;
                            __this.syncBookingPayment()
                            setTimeout(() => {
                                self.$router.push({ name: 'confirmation' })
                                this.closePopup() // close payment modal
                            }, 30000);
                        },
                        onExit: function () {
                            console.log('onExit')
                            if(self.paymentCompleted) {
                                self.$router.push({ name: 'confirmation' })
                            }
                        },
                    }
                );
            })
            .catch(error => {
                console.log(error);
            })
        },
        daysBeforeDeprture() {
            const today = moment()
            const deptDay = moment(this.booking.soonest_departure)
            return deptDay.diff(today, 'days');
        },
        airBookingRefTitle() {
            if (this.daysBeforeDeprture() > 28) {
                return 'Airline booking reference no. will be available 28 days before departure.'
            }
            if (this.booking.balance > 0) {
                return 'Airline booking reference no. will be available after paying due balance.'
            }
            return ''
        },
        airBookingRefText(value) {
            if (this.daysBeforeDeprture() < 28 && this.booking.balance <= 0) {
                return value ? value : 'N/A'
            }
            return 'N/A'
        },
        downloadItinerary() { // To download multiple in itinerary pdfs
            const itinerary_document_type = ['General Holiday Information', 'Check In Instructions', 'Travel Itinerary'];
            itinerary_document_type.map((type) => {
                axios.get(this.$api + 'manage-bookings/' + this.booking.id + '/documents/itinerary', {
                    params: {
                        booking_ref_no: this.verify.booking_ref_no,
                        surname: this.verify.surname,
                        departure_date: this.verify.departure_date,
                        itinerary_document_type: type,
                    },
                    headers: {
                        'Accept': 'application/json',
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    if(response.data) {
                        const _url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = _url
                        link.setAttribute('download', `${this.booking.id} - ${type}.pdf`)
                        document.body.appendChild(link)
                        link.click();
                    }
                });
            });
        },
        emailItinerary() {
            this.$root.loading = true;
            axios.get(this.$api + 'manage-bookings/' + this.booking.id + '/documents/email-itinerary', {
                params: {
                    booking_ref_no: this.verify.booking_ref_no,
                    surname: this.verify.surname,
                    departure_date: this.verify.departure_date,
                },
                headers: {
                    'Accept': 'application/json',
                }
            })
            .then(res => res.data)
            .then(response => {
                console.log(response, 'sasasa')
                this.$root.loading = false;
                if(response.success == true) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                }else if (response.success != true) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            })
            .catch(error => {
                this.$root.loading = false;
                if(error.response.data.message) {
                    this.$notify({
                        type: 'error',
                        title: error.response.data.message
                    });
                }else {
                     this.$notify({
                        type: 'error',
                        title: error.message
                    });
                }
            }) 
        },
        verfiedRedirect(){
            this.changeAcceptance = false
            this.$router.push({ name: 'manage-booking'})
        },
        handleChangeAcceptance(){
            const r = confirm('Click "OK" to confirm Acceptance.');
            if (r == true) {
                axios.post(`${this.$root.$api}manage-bookings/${this.booking.id}/accept-booking-change`, {
                    booking_ref_no: this.verify.booking_ref_no,
                    surname: this.verify.surname,
                    departure_date: this.verify.departure_date,
                })
                .then(res => res.data)
                .then(json => {
                    if (json.status) {
                        this.changeAcceptence = 1
                        this.booking.changes_accepted = 1
                        return;
                    }
                })
                .catch( function (error) {
                    console.log(error)
                })
                
            }
        },
        updatePassengerDetails(passenger_id,index) {
            // Find The Passenger Details based on the passenger ID
            let passengerDetails = this.booking.passengers.find((element) => element.id === passenger_id);

            if (passengerDetails) {
                this.isLoading = true;
                axios.post(`${this.$root.$api}manage-bookings/${this.booking.id}/update-passenger-details`, {
                    booking_ref_no: this.verify.booking_ref_no,
                    surname: this.verify.surname,
                    departure_date: this.verify.departure_date,
                    passenger_id,
                    updatedPassengerDetail: {
                        date_of_birth: passengerDetails.dob,
                        passport_no : passengerDetails.passport_no,
                        passport_nationality : passengerDetails.passport_nationality,
                        passport_expiry : passengerDetails.passport_expiry,
                        passport_issue : passengerDetails.passport_issue,
                        policy_number : passengerDetails.policy_number,
                        insurance_company : passengerDetails.insurance_company,
                        insurance_telephone_number : passengerDetails.insurance_telephone_number,
                    }
                })
                .then(res => res.data)
                .then(json => {
                    this.isLoading = false;
                    if (json.status) {
                        this.$notify({
                            type: 'success',
                            title: json.message
                        });

                        if (passengerDetails.passport_no && passengerDetails.passport_nationality && passengerDetails.passport_expiry && passengerDetails.passport_issue) {
                            this.booking.passengers[index].can_edit_passport_details = false
                        }
                    }
                })
                .catch(function (error) {
                    this.isLoading = false;
                    console.log(error)
                })
                
            }
            
        },
        updateCustomerDetail() {
           this.isLoading = true;
            axios.post(`${this.$root.$api}manage-bookings/${this.booking.id}/update-customer-details`, {
                booking_ref_no: this.verify.booking_ref_no,
                surname: this.verify.surname,
                departure_date: this.verify.departure_date,
                updated_customer_details: {
                    mobile_number:this.booking.customer.mobile_number
                }
            })
            .then(res => res.data)
            .then(json => {
                this.isLoading = false;
                if (json.status) {
                    this.$notify({
                        type: 'success',
                        title: json.message
                    });
                }
            })
            .catch(function (error) {
                this.isLoading = false;
                console.log(error)
            })
            
        },
        syncBookingPayment() {
            axios.post(`${this.$root.$api}manage-bookings/${this.booking.id}/sync-booking-payment`, {
                booking_ref_no: this.verify.booking_ref_no,
                surname: this.verify.surname,
                departure_date: this.verify.departure_date,
            })
            .then(res => res.data)
            .then(json => {
                if (json.status) {
                    
                }
            })
            .catch( function (error) {
                console.log(error)
            })
        }
    }
}
</script>
